import styled from 'styled-components'

import { Placeholder as DefaultPlaceholder } from '@subaio/components'

export const Placeholder = styled(DefaultPlaceholder)`
	line-height: 1px;
`
